let NOSTRO_INITIALIZED = false
class NostoRecommendations {
  constructor() {
    if (!window.nostojs) {
      throw new Error('Nostro Not initialized')
    }
    this._renderNostoInjectCampaigns =
      this._renderNostoInjectCampaigns.bind(this)
    this._callback = this._callback.bind(this)
    this._errorCallback = this._errorCallback.bind(this)
    this._defferedPromise = new Deferred()
    this._attachListeners()
  }

  _attachListeners() {
    window.addEventListener('DOMContentLoaded', this.initializeNosto.bind(this))

    document.addEventListener('click::add-to-cart', (event) => {
      this.trackAddToCart(event.detail.product_id, event.detail.placement_id)
    })

    document.addEventListener('click::quick-shop-toggle', (event) => {
      this.trackProductView(event.detail.product_id, event.detail.placement_id)
    })
  }

  async initializeNosto(templates) {
    if (NOSTRO_INITIALIZED) {
      if (this._loaded) {
        return this._renderNostoInjectCampaigns(this._nostoResponse, templates)
      } else {
        await this._defferedPromise.promise
        return this._renderNostoInjectCampaigns(this._nostoResponse, templates)
      }
    }

    window.nostojs((api) => {
      api
        .createRecommendationRequest({ includeTagging: true })
        .setResponseMode('JSON_ORIGINAL')
        .load()
        .then((res) => {
          this._renderNostoInjectCampaigns(res, templates)
          this._callback(res)
        })
        .catch(this._errorCallback)
    })
    NOSTRO_INITIALIZED = true
  }

  _renderNostoInjectCampaigns(res, templates = []) {
    window.nostojs((api) => {
      const content = {}
      Object.keys(res.recommendations).forEach((id) => {
        if (res.recommendations[id]) {
          content[id] = { ...res.recommendations[id] }

          if (res.recommendations[id].products) {
            const generatedHTML = this.renderMarkup(
              res.recommendations[id],
              id,
              templates
            )

            // Incase there is a error skip this
            if (generatedHTML) {
              content[id] = { ...res.recommendations[id], html: generatedHTML }
            }
          }
        }
      })

      api.placements.injectCampaigns(content)
    })
  }

  get nostoTemplates() {
    return document.getElementById('nosto-templates')
  }

  renderMarkup(recommendation, id, templates) {
    if (!this.nostoTemplates) {
      return
    }

    const nostoElement = document.getElementById(id)
    const templateType = nostoElement.getAttribute('data-template-type') || ''
    if (Array.isArray(templates) && !templates.includes(templateType))
      return null
    const template = this.nostoTemplates.content
      .cloneNode(true)
      .querySelector(`[data-template-type="${templateType}"]`)

    if (!template) return ''

    const title = recommendation.title
    const products = recommendation.products

    template.innerHTML = template.innerHTML
      .replaceAll('%%result_id%%', recommendation.result_id)
      .replaceAll('%%title%%', title)
      .replaceAll('%%products%%', encodeURIComponent(JSON.stringify(products)))

    return template.innerHTML
  }

  _callback(response) {
    this._nostoResponse = response
    this._loaded = true
    this._defferedPromise.resolve(this._nostoResponse)
  }

  _errorCallback(error) {
    this._defferedPromise.reject(error)
  }

  getRecommendation() {
    return new Promise(async (resolve, reject) => {
      if (this._loaded) {
        return resolve(this._nostoResponse)
      }
      try {
        await this._defferedPromise.promise
        return resolve(this._nostoResponse)
      } catch (error) {
        reject(error)
      }
    })
  }

  trackAddToCart(productId, placementID) {
    nostojs(function (api) {
      api.recommendedProductAddedToCart(productId, placementID)
    })
  }

  trackProductView(productId, placementID) {
    nostojs(function (api) {
      api
        .createRecommendationRequest()
        .setProducts([{ product_id: productId }], placementID)
        .load()
    })
  }
}

window.__NOSTO_RECOMMENDER__ = new NostoRecommendations()
